module.exports = __webpack_public_path__ + "img/flavor5.d68f4e48.svg";